
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  imports: [RouterOutlet],
  selector: 'app-sidebar-layout',
  template: `<router-outlet></router-outlet>`,
})
export class AuthLayout {}
